// getEmptyForm — the initial/empty form values for ManualTripCreator.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (the module-level
// `EMPTY_FORM` object used as the `useState` initial value and on reset/after a
// successful create) as part of the behavior-preserving refactor (issue #240).
// Same keys, same empty-string defaults, same order as the source.
//
// Returns a FRESH object on every call, mirroring how the source spread
// `{ ...EMPTY_FORM }` at each use site so no two form states share a reference.
//
// Does NOT read the clock: every default is a fixed empty string, so no `now`
// injection is required.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Build the empty form-data object for the manual trip form.
 *
 * @returns {{ tripName: string, startDate: string, startDestination: string,
 *            endDate: string, endDestination: string }} A fresh empty form.
 */
export function getEmptyForm() {
  return {
    tripName: '',
    startDate: '',
    startDestination: '',
    endDate: '',
    endDestination: ''
  };
}

export default getEmptyForm;
